import {applyMiddleware, createStore} from "redux";
import thunkMiddleware from "redux-thunk";
import {middleware as flashMiddleware} from "redux-flash";
import {routerMiddleware} from "react-router-redux";
import {hashHistory} from "react-router";
import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducers from "./store/reducers";
import { composeWithDevTools } from 'redux-devtools-extension';

/**
 * Middleware
 */
const middleware = [
    thunkMiddleware,
    flashMiddleware(),
    routerMiddleware(hashHistory)
];

/**
 * Persist
 */
const persist = persistReducer({
    key: 'root',
    storage: storage,
    blacklist: [
        'user',
        'language',
        'workspace',
        'layout',
        'flash',
        'routing',
        'media',
        'i18n',
        'layout'
    ]
}, reducers);

/**
 * Store configuration
 */
const store = createStore(persist, composeWithDevTools(applyMiddleware(...middleware)));

export default store;



// WEBPACK FOOTER //
// ./src/core/admin/store.js